export { default as PlatformsStorefrontJumboSmall } from './PlatformsStorefrontJumboSmall';
